@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

.fixed-cell {
	position: sticky;
	left: 0;
}

.empty-cell {
	display: inline-block;
	background-color: inherit;
	color: Colors.$col-greyFontLight;
	font-size: Constants.$val-fontSizeSmall;

	&--header {
		background-color: Colors.$col-greyBackground;
	}
}

.text-cell {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.bold-content {
	font-weight: bold;
}

.link-cell {
	display: flex;
	align-items: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	&>[class^="icon-external"] {
		color: Colors.$col-blue;
		font-weight: bold;
		margin-right: Constants.$val-spacing-s;
		font-size: Constants.$val-fontSizeXBig;
	}

	&>b {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&:hover {
		cursor: pointer;
	}
}

.dollar-cell {
	display: flex;
	justify-content: flex-end;
	width: 100%;

	&__negative {
		color: Colors.$col-red;
	}
}

.percentage-cell {
	display: flex;
	justify-content: flex-end;
	width: 100%;
}

.updated-by-cell {
	display: flex;
	flex-direction: column;
	height: 100%;

	&__time {
		font-size: Constants.$val-fontSizeSmall;
	}

	&__name {
		display: flex;
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyMid;
	}
}


.date-cell {
	display: flex;
	flex-direction: column;
}

.badge {
	opacity: .75;

	&__negative {
		color: Colors.$col-grey;
	}
}
